import React from "react";
import PixPagar from "../../../components/acesso-rapido/pix/pix-pagar/PixPagar";

const TransferirPix = () => {
  return <PixPagar />;
};

export default TransferirPix;
